
import TranResourcesApi from './src/Tranresources'
import RegionList from './src/RegionList'
import PlayList from './src/PlayList'
import ProgramApi from './src/Program'
import TaskApi from './src/Task'
import TaskDeviceApi from './src/TaskDevice'
import TaskPlanApi from './src/TaskPlan'
import TaskProgramApi from './src/TaskProgram'
import BrocastHttpApi from './src/BrocastHttp'


let apis = {
   TranResourcesApi,
   RegionList,
   PlayList,
   ProgramApi,
   TaskApi,
   TaskDeviceApi,
   TaskPlanApi,
   TaskProgramApi,
   BrocastHttpApi
};

export default apis;
